/**
 * Az alappontba (`BASE_GP_PER_KM`) számító táv — a rések nélkül.
 *
 * ⚠️ ÉLES ESET (GRUNDO #72, `36835f5c…`): 3 pontos nyomvonal, köztük egy
 * 4,95 km-es, 24 perces egyenes rés — 20 GP járt érte. Geri döntése: a rés
 * ne kapjon GP-t. A rés definíciója `GP_GAP_MIN_DISTANCE_M` (lásd ott).
 *
 * A levonás UGYANAZOKON a használható pontokon fut, amiből a szerver a
 * távot számolja (`usableTracePoints`), tehát a különbség pontosan a rések
 * hossza. A cellaérintést, a kijelzett távot és a statisztikát nem érinti.
 */

import type { GameplayConfig } from '@/config/gameplay';
import type { TracePoint } from '@/types';
import { distanceM } from './geo';
import { usableTracePoints } from './traceQuality';

/** A rés-szakaszok összhossza méterben. */
export function gapDistanceM(
  points: readonly TracePoint[],
  cfg: Pick<GameplayConfig, 'GP_GAP_MIN_DISTANCE_M'>,
): number {
  const usable = usableTracePoints(points);
  let gaps = 0;
  for (let i = 1; i < usable.length; i += 1) {
    const d = distanceM(usable[i - 1]!, usable[i]!);
    if (d > cfg.GP_GAP_MIN_DISTANCE_M) gaps += d;
  }
  return gaps;
}

/** A GP-alap távja km-ben: a teljes táv mínusz a rések. */
export function gpDistanceKm(
  distanceKm: number,
  points: readonly TracePoint[],
  cfg: Pick<GameplayConfig, 'GP_GAP_MIN_DISTANCE_M'>,
): number {
  return Math.max(0, distanceKm - gapDistanceM(points, cfg) / 1000);
}
